import {AsyncPipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {
    MatCard,
    MatCardActions,
    MatCardContent,
    MatCardHeader,
    MatCardSubtitle,
    MatCardTitle,
} from '@angular/material/card';
import {MatDialog} from '@angular/material/dialog';
import {MatList, MatListItem, MatListItemIcon, MatListItemTitle} from '@angular/material/list';
import {BadgeDialogComponent} from '@app/admin/badge-dialog/badge-dialog.component';
import {Badge, BadgeService} from '@app/badge/badge.service';
import {Observable} from 'rxjs';

@Component({
    selector: 'frog-badge-card',
    templateUrl: './badge-card.component.html',
    styleUrls: ['./badge-card.component.scss'],
    imports: [
        MatCard,
        MatCardHeader,
        MatCardTitle,
        MatCardSubtitle,
        MatCardContent,
        MatList,
        MatListItem,
        MatListItemTitle,
        MatListItemIcon,
        MatCardActions,
        MatButton,
        AsyncPipe,
    ],
})
export class BadgeCardComponent implements OnInit {
    public badges$: Observable<Badge[]>;

    constructor(
        private badgeservice: BadgeService,
        private matDialog: MatDialog,
    ) {}

    ngOnInit(): void {
        this.badges$ = this.badgeservice.badges;
    }

    edit() {
        this.matDialog.open(BadgeDialogComponent, {
            minWidth: '650px',
        });
    }
}
